import React from "react";
const SmileIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#FFD60B" cx="7" cy="7" r="7" />
        <path
          d="M7 0A7 7 0 1 1 .008 6.653 6.323 6.323 0 1 0 6.653.008C6.768.003 6.883 0 7 0Z"
          fill="#FFB000"
        />
        <path
          d="M7 0a6.989 6.989 0 0 1 5.58 2.774 7 7 0 0 0-9.807 9.807A7 7 0 0 1 7 0Z"
          fill="#FFEB97"
        />
        <circle stroke="#975F00" strokeWidth=".677" cx="7" cy="7" r="6.661" />
        <path d="M11.853 7.226a4.29 4.29 0 0 1-8.577 0h8.577Z" fill="#FFF" />
        <path
          d="M11.19 7.75a3.92 3.92 0 0 1-3.69 3.5 3.92 3.92 0 0 1-3.69-3.5h7.38M12 7H3a4.77 4.77 0 0 0 4.5 5A4.77 4.77 0 0 0 12 7Z"
          fill="#975F00"
          fillRule="nonzero"
        />
        <rect
          fill="#000"
          fillRule="nonzero"
          x="5"
          y="4"
          width="2"
          height="2"
          rx="1"
        />
        <rect
          fill="#000"
          fillRule="nonzero"
          x="9"
          y="4"
          width="2"
          height="2"
          rx="1"
        />
      </g>
    </svg>
  )
);
SmileIcon.displayName = "SmileIcon";
export default SmileIcon;
